import styled from "styled-components";

export const StyledTitle = styled.h1`
  @font-face {
    font-family: "Get Schwifty";
    src: url("fonts/get_schwifty.ttf") format("woff");
  }

  position: relative;
  width: 100%;

  .title {
    position: absolute;
    width: 100%;
    top: 4rem;

    text-align: center;
    font-family: "Get Schwifty";
    font-size: 3em;
    color: #08bae3;
    z-index: 50;
    -webkit-text-stroke: 1px rgba(0, 0, 0, 0.5);

    span {
      font-size: 0.5em;
      font-family: "Get Schwifty";
    }
  }

  .title.middle {
    -webkit-text-stroke: 0.1em #fff765;
    z-index: 49;
  }

  .title.bottom {
    -webkit-text-stroke: 0.4em black;
    z-index: 48;
  }
`;
